import { useState, useRef } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    
    const Entries = [
        {
            name: "Glorgo's Microplastic Mine",
            description: "Models I made as a 3D modeler crew member for the 2026 University of Southern California Advanced Games Project, Glorgo's Microplastic Mine. Where I made amongst other things plastic trash props, body mutations that turn the player's head into chomping teeth or their back into windup toys, elevators, pipes, and rubberduckies. It was a neat little Project",
            photos: [
                "/images/works/3DArt/Glorgos/microplastics.png",
                "/images/works/3DArt/Glorgos/teef.png",
                "/images/works/3DArt/Glorgos/suctionCupLegs.png",
                "/images/works/3DArt/Glorgos/GumballHead.png",
                "/images/works/3DArt/Glorgos/elevator1.png",
                "/images/works/3DArt/Glorgos/elevator2.png",
                "/images/works/3DArt/Glorgos/WindupToy.png",
                "/images/works/3DArt/Glorgos/bubberducky.png",
            ]
        },
        {
            name: "Untethered",
            description: "<h1>Models I made for the University of Southern California School of Cinematic Arts class CTIN-489 Games Production Class.</h1><br><br> The game was produced by me and a partner and you can find more about it in the games I've produced section.",
            photos: [
                "/images/works/3DArt/Untethered/PCRender.png",
                "/images/works/3DArt/Untethered/batteryboxbeta.png",
            ]
        },
        {
            name: "What's Wrong With Me",
            description: "Chairs and Laundry Room Props I made for a game produced by my good friend, roommate, and colleague Luna Gary",
            photos: [
                "/images/works/3DArt/W3M/DetergentRender.png",
                "/images/works/3DArt/W3M/stool.png",
                "/images/works/3DArt/W3M/fancyChair.png",
                "/images/works/3DArt/W3M/curlyChair.png",
                "/images/works/3DArt/W3M/swivelChair.png",
                "/images/works/3DArt/W3M/foldingChair.png",

            ]
        },
        {
            name: "6 Dollar Srimp Special",
            description: "A shrimp model I made as a bit to joke with my Friend Kadence. Was also used in the demo, 'Shrimp Fried Beats'",
            photos: [
                "/images/works/3DArt/Srimp/srimp.png",
                "/images/works/3DArt/Srimp/SIX DOLLAR SRIMP SPECIAL.png",
            ]
        },
        {
            name: "Mayhem Pictures",
            description: "A logo I render into 3D for my long time best friend Ameerah Muhammad and her VERY small indie film studio that at the time was called Mayhem Pictures. Listed in the Videos Section should be a rendering of the animation too.",
            photos: [
                "/images/works/3DArt/Mayhem/MayhemLogo.png",
                     
            ]
        }
        
    ]
    
    const [selectedEntry, setSelectedEntry] = useState(Entries[0]);
    const [photoIndex, setPhotoIndex] = useState(0);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    const handleEntryClick = (entry) => {
      setSelectedEntry(entry);
      setPhotoIndex(0);
    };
    
    
    
    const listItems = Entries.map((Entry, index) =>
                                  <div key={index}>
                                  <MenuListItem style={{ whiteSpace: 'normal', height: 'auto' }} onClick={() => {setSelectedEntry(Entry);
        setPhotoIndex(0);}}>{Entry.name}</MenuListItem>
                                  <Separator />
                                  </div>
                                  );
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "800px"}}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>3D Art</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/Backpage')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex', flexDirection: "column" }}>
                <div style={{ 
                    width: '100%', 
                    flex: 5,
                    background: 'black', 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                    }}>
                <img
                    src={selectedEntry.photos[photoIndex]}
                    alt={selectedEntry.name}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                    }}
                />
                </div>
            
              
              <div style={{ display: 'flex', flexDirection: 'row', flex: 3, overflow: 'hidden' }}>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <MenuList style={{ display: 'flex', flexDirection: 'column' }}>
                    {listItems}
                  </MenuList>
                </ScrollView>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <div style={{ padding: '1rem' }}>
                    {selectedEntry.description.split('\n\n').map((para, i) => (
                        <p key={i}>{para}</p>
                        ))}
                  </div>
                </ScrollView>
              </div>
                
              <div style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
              {selectedEntry.photos.length > 1 ?
                    <MenuList inline>
                        
                    <MenuListItem onClick={() => setPhotoIndex(i => Math.max(i - 1, 0))}>Previous</MenuListItem>
                    <MenuListItem onClick={() => setPhotoIndex(i => Math.min(i + 1, selectedEntry.photos.length - 1))}>Next</MenuListItem>
                      </MenuList> : <div></div>
                }
                <Button 
                  className='big-button'
                  style={{ width: '100%', height: '100%', flex: 1, display: "none"}} 
                  fstyle={{ height: '100%', width: '100%', fontSize: '2rem !important' }} 
                  onClick={() => linkOut(selectedEntry.link)}
                >
                  Check this out on Roblox
                </Button>
              </div>
              </Frame>

            
            
            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
